import { IStatus } from '@dfl/mui-react-common';
import { GREEN } from 'settings/theme';

export enum ORDER_STATUS_VALIDATE_TYPE {
  AFTER_PAID = 'AFTER_PAID',
  MANUAL = 'MANUAL',
}

export enum ORDER_STATUS_TYPE_ENUM {
  COMPLETED = 'COMPLETED',
  VALIDATED = 'VALIDATED',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PAID = 'PAID',
  PENDING_REFUNDED = 'PENDING_REFUNDED',
  REFUNDED = 'REFUNDED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED',
  CUSTOM = 'CUSTOM',
  CREATED = 'CREATED',
  FRAUD = 'FRAUD',
  FRAUD_REVIEW = 'FRAUD_REVIEW',
  PENDING_REVIEW = 'PENDING_REVIEW',
}

export const ORDER_STATUS: IStatus[] = Object.keys(ORDER_STATUS_TYPE_ENUM).map((st) => ({
  _id: st,
  title: `orderStatus:fields.orderStatusType.${st}`,
  color: GREEN,
}));
